import React from "react";

const FileReport = ({ fileReportData }) => (
  <div className="p-4 shadow rounded-4">
    <p className="mb-4">
      <strong>File Report</strong>
    </p>
    <table className="table">
      <thead>
        <tr>
          <th className="ps-0">Label</th>
          <th className="pe-0">Value</th>
        </tr>
      </thead>
      <tbody>
        {/* Files by Storage */}
        {fileReportData.filesByStorage && fileReportData.filesByStorage.map((storage, index) => (
          <tr key={index}>
            <td className="ps-0 small">{storage.storage}</td>
            <td className="pe-0 small">{storage.totalFiles}</td>
          </tr>
        ))}
        {/* Large Files */}
        <tr>
          <td className="ps-0 small">{"Large Files (Size > 32MB)"}</td>
          <td className="pe-0 small">{fileReportData.largeFiles || 0}</td>
        </tr>
        {/* Empty Size Files */}
        <tr>
          <td className="ps-0 small">Files with Empty Size</td>
          <td className="pe-0 small">{fileReportData.emptySizeFiles || 0}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default FileReport;
